export enum HttpStatusCodes {
  INFO = 102,
  OK = 200,
  BAD_REQUEST = 400,
  NOT_FOUND = 404,
  CONFLICT = 409,
  CANCELLED = 499,
  INTERNAL_SERVER_ERROR = 500,
}

export interface UsbDataTransfer {
  code: HttpStatusCodes;
  status: string;
  message: string;
  data: {
    trip_files_transferred: number;
    total_trip_files: number;
    progress: number;
    estimated_time_remaining: number;
  };
}
